import moment from 'moment';
import { crossfilter } from 'dc';
import cryptoJS from 'crypto-js';
import { isDesktop, isMobile, osName, osVersion, browserName, fullBrowserVersion, deviceType, mobileModel } from 'react-device-detect';
import constants from './constants';
import { localStoreFN } from '../../store/localStorage';

const objFunction = {
  getTags: obj => {
    let tags = [];

    if (obj.multipleTagsInputIsMultiple) {
      tags = obj.tags;
    } else {
      const count = document.querySelectorAll('[data-autocomplete]').length;
      let i;
      let tag;
      if (obj) {
        for (i = 0; i <= count - 1; i++) {
          if (document.getElementById(`au-${i}`)) {
            if (obj.id == `au-${i}`) {
              tag = obj.value;
              tags.push(tag);
            } else {
              tag = document.getElementById(`au-${i}`);
              tags.push(tag.value);
            }
          }
        }
      }
    }

    return tags;
  },
  getDate: (obj, format) => {
    const dateStart = 'date-start' == obj.id ? obj.date : document.getElementById('date-start').value;
    const dateEnd = 'date-end' == obj.id ? obj.date : document.getElementById('date-end').value;

    const fechaStartFinal = moment(dateStart, format).format('YYYY-MM-DD');
    const fechaEndFinal = moment(dateEnd, format).format('YYYY-MM-DD');

    return {
      fechaStartFinal: objFunction.isValidDate(fechaStartFinal) ? fechaStartFinal : '',
      fechaEndFinal: objFunction.isValidDate(fechaEndFinal) ? fechaEndFinal : ''
    };
  },
  getTaskState: obj => {
    if (obj.target && obj.target.id == 'tasks-state') {
      return obj.target.value;
    } else {
      return document.getElementById('tasks-state').value;
    }
  },
  getTaskType: obj => {
    if (obj.target && obj.target.id == 'tasks-type') {
      return obj.target.value;
    } else {
      return document.getElementById('tasks-type').value;
    }
  },
  getFlowVehicleType: obj => {
    if (obj.target && obj.target.id == 'vehicleType') {
      return obj.target.value;
    } else {
      return document.getElementById('vehicleType').value;
    }
  },
  getFlowDirection: obj => {
    if (obj.target && obj.target.id == 'direction') {
      return obj.target.value;
    } else {
      return document.getElementById('direction').value;
    }
  },
  getFlowStatus: obj => {
    if (obj.target && obj.target.id == 'status') {
      return obj.target.value;
    } else {
      return document.getElementById('status').value;
    }
  },
  getReportType: obj => {
    if (obj.currentTarget && obj.currentTarget.dataset
      && obj.currentTarget.dataset.parent == 'report-type') {
      return obj.currentTarget.dataset.select;
    } else {
      null;
    }
  },
  getPeriodReport: obj => {
    if (obj.target && obj.target.id == 'period-report') {
      return obj.target.value;
    } else {
      return document.getElementById('period-report').value;
    }
  },
  getWorkingShiftGroup: obj => {
    if (obj.target && obj.target.id == 'working-shift-group') {
      return obj.target.value;
    } else {
      return document.getElementById('working-shift-group').value;
    }
  },
  generateCrossfilter: data => {
    var crossfilterDatasource = crossfilter(data);
    crossfilterDatasource.filterDims = {};
    crossfilterDatasource.componentDims = {};
    return crossfilterDatasource;
  },
  prepareWorkshiftGraphData: data => {
    var finalData = [];
    const epochDay = 86400000;
    const epochHour = 3600000;

    for (var i = 0; i < data.shifts.length; i++) {
      var shift = data.shifts[i];
      for (var j = 0; j < shift.length; j++) {
        var segment = shift[j];
        var newSegment = {};

        newSegment.isStart = 0;
        newSegment.isEnd = 0;
        newSegment.zIndex = 1;
        if (j == 0) {
          newSegment.isStart = 1;
          newSegment.isEnd = 1;
          newSegment.zIndex = 0;
        }
        newSegment.startDate = segment.start;
        newSegment.endDate = segment.end;
        newSegment.place = segment.location;
        newSegment.type = segment.activity;
        newSegment.lane = epochDay * parseInt(segment.start / epochDay);
        newSegment.date = newSegment.lane;
        newSegment.start = parseInt((segment.start - newSegment.lane) / epochHour);
        newSegment.length = segment.time / 3600;
        finalData.push(newSegment);
      }
    }
    return finalData;
  },
  getFormatFunction: valueFormatObjectParam => {
    var valueFormatObjectDefault = {
      type: '',
      format: '',
      factor: 1,
      factorOperator: '*',
      sufix: '',
      noDataValue: 'N/A'
    };
    var functionReturned = function(v) {
      return v;
    };
    var valueFormatObject = valueFormatObjectDefault;

    if (valueFormatObjectParam) {
      valueFormatObject = Object.assign({}, valueFormatObjectDefault, valueFormatObjectParam);
    }

    if (valueFormatObject.format != '') {
      if (valueFormatObject.type == 'DATE_TIME') {
        functionReturned = d3.time.format(valueFormatObject.format);
      } else if (valueFormatObject.type == 'DATE_TIME_PARSE_ISO') {
        functionReturned = function(v) {
          var parser = d3.time.format.utc('%Y-%m-%dT%H:%M:%S.%L%Z').parse;
          var date = parser(v);
          date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
          var formatter = d3.time.format(valueFormatObject.format);
          return formatter(date);
        };
      } else if (valueFormatObject.type == 'DATE_TIME_PARSE_ISO_GAUSS') {
        functionReturned = function(v) {
          var parser = d3.time.format.utc('%Y-%m-%d %H:%M:%S').parse;
          var date = parser(v);
          date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
          var formatter = d3.time.format(valueFormatObject.format);
          return formatter(date);
        };
      } else if (valueFormatObject.type == 'DATE_TIME_UTC') {
        functionReturned = function(v) {
          var date = new Date(v);
          date.setTime(v + date.getTimezoneOffset() * 60000);
          var formatter = d3.time.format(valueFormatObject.format);
          return formatter(date);
        };
      } else if (valueFormatObject.type == 'NUMBER') {
        functionReturned = function(v) {
          if (isNaN(v)) {
            return valueFormatObject.noDataValue;
          }
          var value = v;

          switch (valueFormatObject.factorOperator) {
            case '*':
              value = value * valueFormatObject.factor;
              break;
            case '/':
              value = value / valueFormatObject.factor;
              break;
          }

          if (valueFormatObject.format == 'hh:mm') {
            var hour = Math.floor(value);
            var minute = Math.floor((value - hour) * 60);
            var hourString = '00'.substring(0, 2 - hour.toString().length) + hour + 'h';
            var minuteString = '00'.substring(0, 2 - minute.toString().length) + minute + 'm';
            return hourString + ':' + minuteString;
          }
          return d3.format(valueFormatObject.format)(value);
        };
      } else if (valueFormatObject.type == 'STRING') {
        functionReturned = function(v) {
          return v;
        };
      } else if (valueFormatObject.type == 'PARSE_DATE_STRING') {
        functionReturned = function(v) {
          var parser = d3.time.format.utc(valueFormatObject.format[1]).parse;
          var date = parser(v);
          date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
          var formatter = d3.time.format(valueFormatObject.format[0]);
          return formatter(date);
        }
      }
    }

    var functionReturnedWrapper = function(v) {
      if (v == null) {
        return valueFormatObject.noDataValue;
      }
      return functionReturned(v) + valueFormatObject.sufix;
    };

    return functionReturnedWrapper;
  },
  getDateFromNowWithDifference: (days) => {
    var date = new Date();
    date.setDate(date.getDate() - days);
    var formatter = d3.time.format("%Y-%m-%d");
    return formatter(date);
  },
  addDaysToDateString: (dateString,days) => {
    var parser = d3.time.format.utc("%Y-%m-%d").parse;
    var date = parser(dateString);
    date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
    date.setDate(date.getDate() + days);
    var formatter = d3.time.format("%Y-%m-%d");
    return formatter(date);
  },
  compareDateString: (dateString1,dateString2) => {
    var parser = d3.time.format.utc("%Y-%m-%d %H:%M:%S").parse;
    var date1 = parser(dateString1.substring(0,10) + " 00:00:00");
    date1.setTime(date1.getTime() + date1.getTimezoneOffset() * 60000);
    var date2 = parser(dateString2.substring(0,10) + " 00:00:00");
    date2.setTime(date2.getTime() + date2.getTimezoneOffset() * 60000);

    if(date1.getTime()==date2.getTime()) {
      return 0;
    }
    else if(date1.getTime()>date2.getTime()) {
      return 1;
    }
    else {
      return -1;
    }
  },
  getDaysDifference: (dateString1,dateString2) => {
    var parser = d3.time.format.utc("%Y-%m-%d %H:%M:%S").parse;
    var date1 = parser(dateString1.substring(0,10) + " 00:00:00");
    date1.setTime(date1.getTime() + date1.getTimezoneOffset() * 60000);
    var date2 = parser(dateString2.substring(0,10) + " 00:00:00");
    date2.setTime(date2.getTime() + date2.getTimezoneOffset() * 60000);

    return (date2.getTime()-date1.getTime())/(1000*60*60*24) + 1;
  },
  getFormatNowDate: (days) => {
    var date = new Date();
    var formatter = d3.time.format("%Y-%m-%d");
    return formatter(date);
  },
  valueFormatPropType: () => {
    return PropTypes.shape({
      type: PropTypes.oneOf(['NUMBER', 'DATE_TIME_UTC', 'DATE_TIME', 'STRING']).isRequired, //Travel path only for travelDataTable
      format: PropTypes.string.isRequired, //examples: NUMBER -> .0f or d or special format hh:mm to show from float hour number like XXh:XXm, STRING->d , 'DATE_TIME_UTC' -> \"%d-%m-%Y\"
      factor: PropTypes.number, //a number to apply the factorOperator
      factorOperator: PropTypes.oneOf(['*', '/']),
      sufix: PropTypes.string, // default ""
      noDataValue: PropTypes.string //default "N/A"
    });
  },
  getSetting: obj => {
    let main, group, filter;
    const isEnabledUbicationPVT = (obj.isEnabledUbicationPVT === undefined) ? false : obj.isEnabledUbicationPVT;
    const filterUbicationPVT = (obj.filterUbicationPVT === undefined) ? {} : obj.filterUbicationPVT;

    if (obj.setting) {
      main = obj.setting.main ? obj.setting.main : obj.general.main;
      group = obj.setting.group ? obj.setting.group : obj.general.group;

      if (obj.setting.filter) {
        const arr = [];
        obj.filter.forEach(item => {
          obj.setting.filter.forEach(tag => {
            if (item.name == tag) {
              arr.push(item);
            }
          });
        });
        filter = arr;
      } else {
        const arr = [];
        obj.filter.forEach(item => {
          obj.general.filter.forEach(tag => {
            if (item.name == tag) {
              arr.push(item);
            }
          });
        });
        filter = arr;
      }
    } else {
      main = obj.general.main;
      group = obj.general.group;
      filter = obj.filter;
    }

    // if PVT ubication is enabled, add the filters and group
    if (isEnabledUbicationPVT) {
      filter = [...filter, filterUbicationPVT];
      group = [...group, constants.ubicationPVT.toLowerCase()];
    }

    return {
      main,
      group,
      filter
    };
  },
  unionFilters: (filter1, filter2) => {
    let filterKeys = {};
    let unionFilters = [];
    if(filter1 && filter2) {
      filter1.concat(filter2).forEach(item => {
        if(!filterKeys[item.name]) {
          filterKeys[item.name] = true;
          unionFilters.push(item);
        }
      });
    }
    else if(filter1) {
      unionFilters = filter1;
    }
    else if(filter2) {
      unionFilters = filter2;
    }
    return unionFilters;
  },
  unionArrays: (array1, array2) => {
    let arraysKeys = {};
    let unionArray = [];
    if(array1 && array2) {
      array1.concat(array2).forEach(item => {
        if(!arraysKeys[item]) {
          arraysKeys[item] = true;
          unionArray.push(item);
        }
      });
    }
    else if(array1) {
      unionArray = array1;
    }
    else if(array2) {
      unionArray = array2;
    }
    return unionArray;
  },
  getColorCategory: (range, value, forceColor = null) => {
    var color = constants.colorRange.default;
    if(forceColor) {
      return forceColor;
    }
    if (range) {
      for (var key in range) {
        if (
          value >= range[key][0] &&
          (range[key][1] == null || value < range[key][1]) &&
          key in constants.colorRange
        ) {
          color = constants.colorRange[key];
        }
      }
    }
    return color;
  },
  interval: count => {
    if (count < 7) {
      return 1;
    } else if (count >= 7 && count <= 14) {
      return 2;
    } else {
      let value = count / 5;
      return Math.round(value);
    }
  },
  getTimeIntervalsArray: (minInterval, vehicleType = null, actualValue = null) => {
    var timeItems = {items:[]};
    for(var i=0; i<=23; i++) {
      for(var j=0; j<=59; j=j+minInterval) {
        if(!(vehicleType == "Sobredimensión" && i>=6)
          && !(vehicleType == "Sustancias Peligrosas" && i>=6)
          && !(vehicleType == "Mayor a 10 mts" && i>=6 && i<21)
          && !(vehicleType == "Menor a 10 mts" && ((i>=6 && i<8) || (i>=18 && i<21) || (i==8 && j<30)))) {
          timeItems.items.push({
            name:i.toString().padStart(2, "0") + ":" + j.toString().padStart(2, "0"),
            state: true
          });
        }
      }
    }
    //in case the edited value is not in the list, we added
    if(actualValue!=null && actualValue!="") {
      var addValue = true;
      for(var i=0; i<timeItems.items.length; i++) {
        var itemName = timeItems.items[i].name;
        if(itemName==actualValue) {
          addValue = false;
          break;
        }
      }
      if(addValue) {
          timeItems.items.push({
            name: actualValue,
            state: true
          });
      }
    }
    return timeItems;
  },
  /**
   * validates that the queried url has the correct format
   * @param {string} url url consulted
   * @returns true if the url is valid, false if it is invalid
   */
  isValidUrl: (url) => {
    try {
      if (!url) {
        return false;
      }

      const objUrl = new URL(url);
      if (objUrl.protocol === 'http:' || objUrl.protocol === 'https:') {
        return true;
      } else {
        return false;
      }
    }
    catch(e){
      return false;
    }
  },
  /**
   * clone an object to another memory address
   * @param {object} obj object to clone
   * @returns cloned object at another memory address
   */
  cloneObject: (obj) => {
    if (typeof(structuredClone) === 'function') {
      return structuredClone(obj);
    } else {
      return JSON.parse(JSON.stringify(obj));
    }
  },
  /**
   * get person id from object or list
   * @param {object} obj object with person information
   * @param {array} listPersons list of people
   * @returns person ID
   */
  getPersonId: (obj, listPersons) => {
    const element = document.getElementById('personId');
    let personId = '';
    let value, findPerson;

    // if the information comes in the object, it gets it from there, otherwise it gets it from the document element
    if (obj.id === 'personId') {
      personId = obj.value;
    } else {
      if (element) {
        value = element.value;
        findPerson = listPersons.find(item => item.value === value);
        if (findPerson) {
          personId = findPerson.key;
        }
      }
    }

    personId = (personId === 'TODOS' || personId === 'ALL') ? '' : personId;
    return personId;
  },
  /**
   * get type and subtype from object or list
   * @param {object} obj object with the information of the types and subtypes
   * @param {array} listTypes list of types
   * @returns object with type and subtype found
   */
  getTypeSubtype: (obj, listTypes) => {
    const elementType = document.getElementById('type');
    const elementSubtype = document.getElementById('subtype');
    let type = '';
    let subtype = '';
    let value, findType;

    // if the information comes in the object, it gets it from there, otherwise it gets it from the document element
    if (obj.id === 'type-subtype') {
      type = obj.payload.type.value;
      subtype = obj.payload.subtype.value;
    } else {
      if (elementType) {
        value = elementType.value;
        findType = listTypes.find(item => item.value === value);
        if (findType) {
          type = findType.key;
        }
      }

      if (elementSubtype) {
        value = elementSubtype.value;

        if (type !== 'TODOS' && type !== 'ALL' && type !== '') {
          const findSubtype = findType.subtypes.find(item => item.value === value);
          if (findSubtype) {
            subtype = findSubtype.key;
          }
        }
      }
    }

    type = (type === 'TODOS' || type === 'ALL') ? '' : type;
    subtype = (subtype === 'TODOS' || subtype === 'ALL') ? '' : subtype;

    return {
      type,
      subtype
    };
  },
  /**
   * validates that the date range to download a report is not greater than 3 months
   * @param {string} dateStart start date in the format YYYY-MM-DD HH:mm:ss
   * @param {string} dateEnd term date with the format YYYY-MM-DD HH:mm:ss
   * @returns true if date range is less than 3 months
   */
  validateReportDownload: (dateStart, dateEnd) => {
    let showErrorDownload = false;

    if (dateStart && dateEnd) {
      const momentStart = moment(dateStart);
      const momentEnd = moment(dateEnd);
      const momentMaxEndDownload = moment(dateStart).add(3, 'months').add(-1, 'days');

      const diffDaysFilters = momentEnd.diff(momentStart, 'days');
      const diffMaxDaysDownload = momentMaxEndDownload.diff(momentStart, 'days');
      showErrorDownload = (diffDaysFilters <= diffMaxDaysDownload) ? false : true;
    }

    return showErrorDownload;
  },
  /**
   * validates if the date format is YYYY-MM-DD
   * @param {string} value date in the format YYYY-MM-DD
   * @returns true if the YYYY-MM-DD format is correct
   */
  isValidDate: (value) => {
    const regex = /^(\d{4})-(\d{2})-(\d{2})$/;

    if (value.match(regex) === null) {
      return false;
    }

    const date = new Date(value);
    const timestamp = date.getTime();

    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
      return false;
    }

    return date.toISOString().startsWith(value);
  },
  /**
   * gets if PVT ubication is enabled
   * @param {object} obj object with settings information
   * @returns true if enabled, else false
   */
  getIsEnabledUbicationPVT: (obj) => {
    const isEnabledUbicationPVT = (obj.generalSetting.isEnabledUbicationPVT === undefined) ? false : obj.generalSetting.isEnabledUbicationPVT;
    return isEnabledUbicationPVT;
  },
  /**
   * converts a date to ISO format YYYY-MM-DD
   * @param {string} date date to convert
   * @param {string} format date format
   * @returns date in the format YYYY-MM-DD
   */
  getDateISO: (date, format) => {
    let dateISO = moment(date, format).format('YYYY-MM-DD');
    dateISO = objFunction.isValidDate(dateISO) ? dateISO : '';
    return dateISO;
  },
  /**
   * validates that the date range to download a report is not greater than 31 days
   * @param {string} dateStart start date in the format YYYY-MM-DD HH:mm:ss
   * @param {string} dateEnd term date with the format YYYY-MM-DD HH:mm:ss
   * @returns true if the date range is less than 31 days
   */
  validateFFDReportDownload: (dateStart, dateEnd) => {
    let showErrorDownload = false;

    if (dateStart && dateEnd) {
      const momentStart = moment(dateStart);
      const momentEnd = moment(dateEnd);
      const maxDaysDownload = 31;

      // includes the last day
      const diffDaysFilters = momentEnd.diff(momentStart, 'days') + 1;
      showErrorDownload = (diffDaysFilters <= maxDaysDownload) ? false : true;
    }

    return showErrorDownload;
  },
  /**
   * gets a random number within the specified range
   * @param {number} min minimum range value
   * @param {number} max maximum value of the range
   * @returns random number from specified range
   */
  getRandomNumber: (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  /**
   * get a random name for a file
   * @param {string} extension file extension
   * @returns a random file name
   */
  getRandomFilename: (extension) => {
    const num = objFunction.getRandomNumber(1000, 9999);
    const name = `file-${num}-${Date.now()}.${extension}`;
    return name;
  },
  /**
   * encodes a text string to Base64.
   * @param {string} text the text to encode
   * @returns {string} the Base64-encoded string
   */
  encoderBase64: (text) => {
    const encodedWord = cryptoJS.enc.Utf8.parse(text);
    const encoded = cryptoJS.enc.Base64.stringify(encodedWord);
    return encoded;
  },
  /**
   * decodes a Base64-encoded string to text.
   * @param {string} encoded the Base64-encoded string to decode
   * @returns {string|null} the decoded text, or null if decoding fails
   */
  decoderBase64: (encoded) => {
    try {
      const encodedWord = cryptoJS.enc.Base64.parse(encoded);
      const decoded = cryptoJS.enc.Utf8.stringify(encodedWord);
      return decoded;
    } catch (error) {
      return null;
    }
  },
  /**
   * handles redirection based on data received from a URL parameter.
   * @param {object} history the history object provided by react-router-dom.
   * @param {string} isAuthenticated determines if the user is authenticated.
   */
  shouldRedirectFromUrl: (history, isAuthenticated) => {
    const redirectData = localStoreFN().getItem(constants.localStorage.redirectData);
    let mustRedirect;

    if (isAuthenticated && redirectData !== null && redirectData !== '') {
      let objData = objFunction.decoderBase64(redirectData);
      objData = JSON.parse(objData);

      switch (objData.path) {
        case '/tasks_manager_detail':
          history.replace(objData.path);
          localStoreFN().setItem(constants.localStorage.tasksManagerDetailData, redirectData);
          break;
        default:
          break;
      }

      localStoreFN().removeItem(constants.localStorage.redirectData);
      mustRedirect = true;
    } else {
      mustRedirect = false;
    }

    return mustRedirect;
  },
  /**
   * Gets metadata about the browser, including information about the device and operating system.
   *
   * @function
   * @name getBrowserMetadata
   * @returns {Object} Object containing browser metadata.
   * @property {string} deviceType - Type of device, defaults to 'desktop' if deviceType is 'browser'.
   * @property {boolean} isMobile - Indicates whether the device is mobile.
   * @property {boolean} isDesktop - Indicates whether the device is desktop.
   * @property {string} osName - Name of the operating system.
   * @property {string} osVersion - Operating system version.
   * @property {string} browserName - Name of the browser.
   * @property {string} fullBrowserVersion - Full version of the browser.
   * @property {string} mobileModel - Model of the mobile device (if applicable).
   */
  getBrowserMetadata: () => {
    return {
      deviceType: (deviceType === 'browser') ? 'desktop' : deviceType,
      isMobile,
      isDesktop,
      osName,
      osVersion,
      browserName,
      fullBrowserVersion,
      mobileModel
    };
  },
  /**
   * Encodes a string by replacing special characters with their HTML entities.
   *
   * @param {string} input - The input string to encode.
   * @returns {string} - The encoded string with HTML entities.
   */
  encodeHTML: (input) => {
    // Create a map of special characters and their corresponding HTML entities
    const characterMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;',
      '`': '&#x60;',
      '=': '&#x3D;'
    };

    // Use a regular expression to find the special characters and replace them
    return input.replace(/[&<>"'`=/]/g, (character) => characterMap[character]);
  },
  /**
   * Sorts an array of objects by a given property.
   *
   * @param {Array} array - The array of objects to sort.
   * @param {string} field - The field to sort by.
   * @param {string} order - The order of the sort, either 'ASC' or 'DESC'.
   * @returns {Array} A new array with the sorted objects.
   */
  sortByField: (array, field, order) => {
    if (!Array.isArray(array)) {
      console.error('sortByField expects an array as first parameter');
      return array;
    }

    // Create a deep copy of the array to avoid modifying the original
    const sorted = JSON.parse(JSON.stringify(array));

    // Sort the array by the specified field
    return sorted.sort((a, b) => {
      // Handle cases where the field may not exist in some objects
      const aVal = a[field] !== undefined ? a[field] : '';
      const bVal = b[field] !== undefined ? b[field] : '';

      // Sort in ascending or descending order as specified
      if (order === 'ASC') {
        // If strings, ignore case
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
        }
        return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
      } else {
        // If strings, ignore case
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return bVal.localeCompare(aVal, undefined, { sensitivity: 'base' });
        }
        return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
      }
    });
  },
};

export default objFunction;



// WEBPACK FOOTER //
// ./source/client/containers/function/index.js